/**
 * words-happen-gql's GET endpoint, on the API's origin (apiOrigin), that Cloud Run's startup and liveness probes call.
 * It answers only once the application has started and reached the database through the tunnel.
 */
export const HEALTH_CHECK_PATH = '/health-check';

/** The health check URL on `apiOrigin`, e.g. https://api.wordshappen.dev/health-check. */
export const healthCheckUrl = (apiOrigin: string): string => new URL(HEALTH_CHECK_PATH, apiOrigin).href;
